import script from "./ModalBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalBase.vue?vue&type=script&setup=true&lang=ts"

import "./ModalBase.vue?vue&type=style&index=0&id=dea9cc9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dea9cc9e"]])

export default __exports__